var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 185,
    viewBox: "0 0 185 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2396_1432)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_2396_1432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.738 110.684C120.112 108.469 124.542 110.885 124.542 114.913V121.408C124.542 127.801 119.558 134.649 113.567 136.662L97.5062 141.999C94.6868 142.956 90.1053 142.956 87.3363 141.999L71.2759 136.662C65.2344 134.649 60.3005 127.801 60.3005 121.408V114.863C60.3005 110.885 64.7309 108.469 68.0538 110.633L78.4251 117.38C82.4024 120.048 87.437 121.357 92.4716 121.357C97.5062 121.357 102.541 120.048 106.518 117.38L116.738 110.684Z",
    fill: "url(#paint0_linear_2396_1432)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.59 64.4669L102.432 44.6809C96.9949 41.1064 88.0333 41.1064 82.5959 44.6809L52.2876 64.4669C42.5708 70.7602 42.5708 85.0081 52.2876 91.3517L60.343 96.5877L82.5959 111.087C88.0333 114.662 96.9949 114.662 102.432 111.087L131.432 92.0565V107.462C131.432 109.527 133.143 111.238 135.208 111.238C137.272 111.238 138.983 109.527 138.983 107.462V82.6922C140.997 76.1976 138.933 68.6456 132.59 64.4669Z",
    fill: "url(#paint1_linear_2396_1432)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_2396_1432",
    x: 15.6764,
    y: 35.6764,
    width: 153.374,
    height: 159.363,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 23
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.6618
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.458824 0 0 0 0 0.803922 0 0 0 0 0.776471 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2396_1432"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2396_1432",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.758333 0 0 0 0 0.541667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2396_1432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2396_1432",
    x1: 84.3114,
    y1: 42,
    x2: 202.035,
    y2: 178.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AFF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448DFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2396_1432",
    x1: 84.3114,
    y1: 42,
    x2: 202.035,
    y2: 178.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AFF9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448DFB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2396_1432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 185,
    height: 185,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLms);
export default __webpack_public_path__ + "static/media/IconLMS.430cd27a734b43d9c31380341de78471.svg";
export { ForwardRef as ReactComponent };